import { all, fork, takeLatest, put } from "redux-saga/effects";
import { getMessage } from "../../libs/hooks";
import { scrollToMessage } from "../../libs/services";
import { addMessagesLoader, setScrolledMessage } from "./actions";
import { GoToMessageType, GO_TO_MESSAGE } from "./types";
import { ClientGetRoomHistory } from "../../proto/ClientGetRoomHistory_pb";

function* onGoToMessage() {
  yield takeLatest<GoToMessageType>(GO_TO_MESSAGE, function* (action) {
    const { messageId, roomId, hasPriority } = action.payload;

    yield getMessage(messageId, roomId);

    yield scrollToMessage(messageId, roomId, { hasPriority, retryLimit: 3 });

    yield put(
      addMessagesLoader({
        roomId,
        direction: [ClientGetRoomHistory.Direction.DOWN, ClientGetRoomHistory.Direction.UP],
        fromMessageId: messageId,
        toMessageId: messageId,
      })
    );

    yield put(setScrolledMessage({ [roomId]: { messageId, lastMessageInView: true } }));
  });
}

export function* messagesSaga() {
  yield all([fork(onGoToMessage)]);
}
